import clsx from 'clsx';
import BottomBar from './BottomBar.jsx';

function BottomBarArea({ sticky = true, children }) {
  return (
    <div className={clsx(sticky && 'sticky-bottom')}>
      {children}
      <BottomBar message={"Live data is currently unavailable for Townsville Harbour and Ross River Dam."} severity="alert" />
    </div>
  );
}

export default BottomBarArea;
